(() => {
  console.log('Ingredients Journey v2.6 - Progress-based animation loaded');
  const root = document.getElementById('ingredients-journey');
  if (!root || root.classList.contains('is-disabled')) return;

  const readyForGSAP = () =>
    typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';

  const waitForGSAP = (cb) => {
    if (readyForGSAP()) return cb();
    const id = setInterval(() => {
      if (readyForGSAP()) {
        clearInterval(id);
        cb();
      }
    }, 50);
  };

  waitForGSAP(() => {
    const gsap = window.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);

    const scenes = [...root.querySelectorAll('.ij-scene-copy')];
    const sceneCount = scenes.length;
    if (sceneCount === 0) return;

    // Get all video elements
    const videos = [...root.querySelectorAll('.ij-layer.bg.video')];
    
    // Handle user interaction to enable video playback (browser autoplay policy)
    const enableVideoPlayback = () => {
      videos.forEach(video => {
        if (video.paused && video.readyState >= 2) {
          video.play().catch(err => {
            console.log('Video play failed after interaction:', err);
          });
        }
      });
    };
    
    // Try to enable video playback on first user interaction
    ['click', 'touchstart', 'scroll'].forEach(eventType => {
      document.addEventListener(eventType, enableVideoPlayback, { once: true, passive: true });
    });

    // Read scroll length and hold time from each scene and calculate cumulative boundaries
    const sceneScrollLengths = [];
    const sceneHoldTimes = [];
    const sceneBoundaries = [0]; // Start at 0
    let totalScrollLength = 0;

    scenes.forEach((scene, idx) => {
      const sceneLength = Number(scene.getAttribute('data-scene-scroll-length')) || 2500;
      const holdTime = Number(scene.getAttribute('data-scene-hold-time')) || 500;
      const totalSceneLength = sceneLength + holdTime; // Add hold time to total scene length
      sceneScrollLengths.push(sceneLength);
      sceneHoldTimes.push(holdTime);
      totalScrollLength += totalSceneLength;
      sceneBoundaries.push(totalScrollLength);
      console.log(`Scene ${idx}: ${sceneLength}px + ${holdTime}px hold = ${totalSceneLength}px (cumulative: ${totalScrollLength}px)`);
    });

    
    // Get section height from data attribute (in vh units, e.g., 100 = 100vh)
    const sectionHeightVH = Number(root.getAttribute('data-section-height')) || 100;
    const sectionHeight = `${sectionHeightVH}vh`;
    
    // Set initial section height based on setting
    root.style.height = sectionHeight;
    root.style.minHeight = sectionHeight;
    
    // Set copy container to section height for scenes
    const copyContainer = root.querySelector('.ij-copy');
    if (copyContainer) {
      copyContainer.style.height = sectionHeight;
      copyContainer.style.position = 'relative';
    }

    // Initialize
    scenes.forEach((scene, idx) => {
      gsap.set(scene, { opacity: idx === 0 ? 1 : 0, pointerEvents: idx === 0 ? 'auto' : 'none' });
      if (idx === 0) {
        scene.classList.add('is-visible');
        scene.style.pointerEvents = 'auto';
      } else {
        scene.classList.remove('is-visible');
        scene.style.pointerEvents = 'none';
      }
      
      // Initialize foreground image
      const fgImage = scene.querySelector('.ij-foreground-image');
      if (fgImage) {
        gsap.set(fgImage, { opacity: idx === 0 ? 1 : 0 });
      }

      // Initialize video
      const sceneVideo = root.querySelector(`.ij-layer.bg.video.scene-${idx}`);
      if (sceneVideo) {
        gsap.set(sceneVideo, { opacity: idx === 0 ? 1 : 0 });
        // Set video to play when visible
        sceneVideo.addEventListener('loadeddata', () => {
          if (idx === 0) {
            sceneVideo.play().catch(err => {
              console.log('Video autoplay failed:', err);
            });
          }
        });
        // Try to play immediately if already loaded
        if (sceneVideo.readyState >= 2 && idx === 0) {
          sceneVideo.play().catch(err => {
            console.log('Video autoplay failed:', err);
          });
        }
      }
      
      // Initialize background images
      const sceneBg = root.querySelector(`.ij-layer.bg.scene-${idx}:not(.video)`);
      if (sceneBg) {
        gsap.set(sceneBg, { opacity: idx === 0 ? 1 : 0 });
      }
      
      const animateText = scene.getAttribute('data-animate-text') === 'true';
      
      // Initialize all text elements
      const allTexts = scene.querySelectorAll('.ij-h1, .ij-sub, .ij-body, .ij-cta, .ij-bullet-item, .ij-feature-item, .ij-product-step, .ij-trust-section, .ij-ingredient-card, .ij-expert-quote, .ij-customer-testimonial, .ij-before-after, .ij-conclusion, .ij-bridge-text, .ij-kit-showcase, .ij-professional-use');
      
      // Initialize hero content wrapper visibility (always visible, children controlled below)
      const heroContent = scene.querySelector('.ij-hero-content');
      if (heroContent) {
        // First scene hero content should fade in, not start visible
        gsap.set(heroContent, { opacity: idx === 0 ? 0 : 1 });
      }
      
      // Initialize product step header elements (always visible, not animated)
      const productStepHeader = scene.querySelector('.ij-product-step-header');
      if (productStepHeader) {
        gsap.set(productStepHeader, { opacity: 1, y: 0 });
      }
      const productStepMainTitle = scene.querySelector('.ij-product-step-main-title');
      if (productStepMainTitle) {
        gsap.set(productStepMainTitle, { opacity: 1, y: 0 });
      }
      const productStepSubtitle = scene.querySelector('.ij-product-step-subtitle');
      if (productStepSubtitle) {
        gsap.set(productStepSubtitle, { opacity: 1, y: 0 });
      }
      
      // Overlay is controlled by inline style from Liquid template - don't touch it with GSAP
      
      // Initialize bullet items, feature items, trust sections, product steps, and ingredient cards separately (they have their own animation logic)
      const bulletItems = scene.querySelectorAll('.ij-bullet-item');
      bulletItems.forEach(item => {
        gsap.set(item, { opacity: 0, y: 20 });
      });
      
      const featureItems = scene.querySelectorAll('.ij-feature-item');
      featureItems.forEach(item => {
        gsap.set(item, { opacity: 0, y: 20 });
      });
      
      const trustSections = scene.querySelectorAll('.ij-trust-section');
      trustSections.forEach(section => {
        gsap.set(section, { opacity: 0, y: 30 });
      });
      
      const productSteps = scene.querySelectorAll('.ij-product-step');
      productSteps.forEach(step => {
        gsap.set(step, { opacity: 0, y: 30 });
      });
      
      const ingredientCards = scene.querySelectorAll('.ij-ingredient-card');
      ingredientCards.forEach(card => {
        gsap.set(card, { opacity: 0, y: 30 });
      });
      
      // Initialize social proof elements
      const expertQuote = scene.querySelector('.ij-expert-quote');
      if (expertQuote) gsap.set(expertQuote, { opacity: 0, y: 30 });
      const customerTestimonial = scene.querySelector('.ij-customer-testimonial');
      if (customerTestimonial) gsap.set(customerTestimonial, { opacity: 0, y: 30 });
      const beforeAfter = scene.querySelector('.ij-before-after');
      if (beforeAfter) gsap.set(beforeAfter, { opacity: 0, y: 30 });
      const professionalUse = scene.querySelector('.ij-professional-use');
      if (professionalUse) gsap.set(professionalUse, { opacity: 0, y: 20 });
      
      // Initialize story sections
      const storySections = scene.querySelectorAll('.ij-story-section');
      storySections.forEach(section => {
        gsap.set(section, { opacity: 0, y: 30 });
      });
      
      // Initialize founder scene elements
      const founderHeadline = scene.querySelector('.ij-founder-headline');
      if (founderHeadline) gsap.set(founderHeadline, { opacity: 0, y: 20 });
      const founderQuote = scene.querySelector('.ij-founder-quote');
      if (founderQuote) gsap.set(founderQuote, { opacity: 0, y: 30 });
      const founderBody = scene.querySelector('.ij-founder-body');
      if (founderBody) gsap.set(founderBody, { opacity: 0, y: 30 });
      const founderSignature = scene.querySelector('.ij-founder-signature');
      if (founderSignature) gsap.set(founderSignature, { opacity: 0, y: 20 });
      const founderImage = scene.querySelector('.ij-founder-image');
      if (founderImage) gsap.set(founderImage, { opacity: 0, y: 30 });
      
      // Initialize product step single scenes
      const productStepSingle = scene.querySelector('.ij-product-step-single');
      if (productStepSingle) {
        const stepImage = productStepSingle.querySelector('.ij-product-step-image');
        const stepContent = productStepSingle.querySelector('.ij-product-step-content');
        if (stepImage) gsap.set(stepImage, { opacity: 0, y: 30 });
        if (stepContent) gsap.set(stepContent, { opacity: 0, y: 30 });
      }
      
      if (idx === 0) {
        // First scene
        if (animateText) {
          // Staggered: only header visible initially
          const h1 = scene.querySelector('.ij-h1');
          const sub = scene.querySelector('.ij-sub');
          const body = scene.querySelector('.ij-body');
          const cta = scene.querySelector('.ij-cta');
          if (h1) gsap.set(h1, { opacity: 1, y: 0 });
          if (sub) gsap.set(sub, { opacity: 0, y: 40 });
          if (body) gsap.set(body, { opacity: 0, y: 40 });
          if (cta) gsap.set(cta, { opacity: 0, y: 40 });
          
          // Initialize nested elements as hidden (but not bullet/feature items, trust sections, product steps, ingredient cards, social proof elements, or founder elements, they're handled above)
          allTexts.forEach(text => {
            if (!text.classList.contains('ij-h1') && !text.classList.contains('ij-bullet-item') && !text.classList.contains('ij-feature-item') && !text.classList.contains('ij-trust-section') && !text.classList.contains('ij-product-step') && !text.classList.contains('ij-ingredient-card') && !text.classList.contains('ij-expert-quote') && !text.classList.contains('ij-customer-testimonial') && !text.classList.contains('ij-before-after') && !text.classList.contains('ij-professional-use') && !text.classList.contains('ij-founder-headline') && !text.classList.contains('ij-founder-quote') && !text.classList.contains('ij-founder-body') && !text.classList.contains('ij-founder-signature')) {
              gsap.set(text, { opacity: 0, y: 40 });
            }
          });
        } else {
          // All text visible (but bullet/feature items, trust sections, product steps, ingredient cards, social proof elements, and founder elements still animated separately)
          allTexts.forEach(text => {
            if (!text.classList.contains('ij-bullet-item') && !text.classList.contains('ij-feature-item') && !text.classList.contains('ij-trust-section') && !text.classList.contains('ij-product-step') && !text.classList.contains('ij-ingredient-card') && !text.classList.contains('ij-expert-quote') && !text.classList.contains('ij-customer-testimonial') && !text.classList.contains('ij-before-after') && !text.classList.contains('ij-professional-use') && !text.classList.contains('ij-founder-headline') && !text.classList.contains('ij-founder-quote') && !text.classList.contains('ij-founder-body') && !text.classList.contains('ij-founder-signature')) {
              gsap.set(text, { opacity: 1, y: 0 });
            }
          });
        }
      } else {
        // Other scenes: all hidden initially (but bullet/feature items, trust sections, product steps, ingredient cards, social proof elements, and founder elements handled above)
        allTexts.forEach(text => {
          if (!text.classList.contains('ij-bullet-item') && !text.classList.contains('ij-feature-item') && !text.classList.contains('ij-trust-section') && !text.classList.contains('ij-product-step') && !text.classList.contains('ij-ingredient-card') && !text.classList.contains('ij-expert-quote') && !text.classList.contains('ij-customer-testimonial') && !text.classList.contains('ij-before-after') && !text.classList.contains('ij-professional-use') && !text.classList.contains('ij-founder-headline') && !text.classList.contains('ij-founder-quote') && !text.classList.contains('ij-founder-body') && !text.classList.contains('ij-founder-signature')) {
            gsap.set(text, { opacity: 0, y: 40 });
          }
        });
      }
    });
    

    // Pin - standalone: section is fixed during scroll, then continues normally
    // pinSpacing: true adds the scroll space automatically
    const pinTrigger = ScrollTrigger.create({
      trigger: root,
      start: 'top top',
      end: `+=${totalScrollLength}px`,
      pin: true,
      pinSpacing: true, // This adds the scroll space needed
      invalidateOnRefresh: true,
      anticipatePin: 1,
      onLeave: () => {
        // Pin releases - section continues scrolling normally
        root.style.position = '';
        root.style.top = '';
        root.style.left = '';
        root.style.width = '';
        // Reset section height to normal after pin
        root.style.height = '';
      },
      onLeaveBack: () => {
        // Reset when scrolling back up
        root.style.position = '';
        root.style.top = '';
        root.style.left = '';
        root.style.width = '';
        root.style.height = sectionHeight;
      }
    });
    
    // Debug: Check actual heights after pinning
    setTimeout(() => {
      const computedHeight = window.getComputedStyle(root).height;
      const computedMarginBottom = window.getComputedStyle(root).marginBottom;
      console.log('Section computed height:', computedHeight);
      console.log('Section margin-bottom:', computedMarginBottom);
      console.log('Section offsetHeight:', root.offsetHeight);
    }, 100);

    // Extract animation logic to a function so we can call it immediately
    function updateAnimations(progress, totalScrollLength) {
      const currentScrollPX = progress * totalScrollLength; // Current scroll position in pixels
        
      // Find which scene we're in based on cumulative boundaries
      let currentSceneIndex = 0;
      for (let i = 0; i < sceneBoundaries.length - 1; i++) {
        if (currentScrollPX >= sceneBoundaries[i] && currentScrollPX < sceneBoundaries[i + 1]) {
          currentSceneIndex = i;
          break;
        }
      }
      // Handle edge case at the very end
      if (currentScrollPX >= sceneBoundaries[sceneBoundaries.length - 1]) {
        currentSceneIndex = sceneCount - 1;
      }
      
      // Calculate progress within the current scene (0 to 1)
      const sceneStartPX = sceneBoundaries[currentSceneIndex];
      const sceneEndPX = sceneBoundaries[currentSceneIndex + 1];
      const rawSceneProgress = (currentScrollPX - sceneStartPX) / (sceneEndPX - sceneStartPX);
      
      // Adjust progress to account for hold time - animations complete earlier, then hold
      const sceneLength = sceneScrollLengths[currentSceneIndex];
      const holdTime = sceneHoldTimes[currentSceneIndex];
      const totalSceneLength = sceneLength + holdTime;
      const animationEndProgress = sceneLength / totalSceneLength; // Point where animations should complete
      
      // Map raw progress (0 to 1) to adjusted progress where animations complete at animationEndProgress
      // After animationEndProgress, progress "holds" at 1.0 until the scene ends
      let sceneProgress;
      const isInHoldPhase = rawSceneProgress > animationEndProgress;
      if (rawSceneProgress <= animationEndProgress) {
        // Normal animation phase: map 0-animationEndProgress to 0-1
        sceneProgress = rawSceneProgress / animationEndProgress;
      } else {
        // Hold phase: keep progress at 1.0 (all animations stay at full visibility)
        sceneProgress = 1.0;
      }

      scenes.forEach((scene, idx) => {
        if (idx === currentSceneIndex) {
          // Current scene: smoother fade transitions with more overlap
          // During hold time (isInHoldPhase = true), keep opacity at 1
          let opacity = 1;
          // First scene (idx === 0) should start fully visible, no fade in
          if (idx === 0) {
            opacity = 1; // Always fully visible for first scene
          } else if (rawSceneProgress < 0.15) {
            opacity = rawSceneProgress / 0.15; // Fade in over first 15% of raw progress
          } else if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.85) {
            // Only fade out if we're transitioning (not in hold phase) and near the end
            // Fade out over last 15% of the total scene (including hold time)
            opacity = (1 - rawSceneProgress) / 0.15; // Fade out over last 15% of total scene
          } else if (idx < sceneCount - 1 && isInHoldPhase && rawSceneProgress > 0.98) {
            // During hold phase, only start fading out in the very last 2% when transitioning
            opacity = (1 - rawSceneProgress) / 0.02; // Fade out over last 2% of total scene
          }
          // During hold time (before 98% of raw progress), opacity stays at 1
          gsap.set(scene, { opacity: opacity, pointerEvents: 'auto' });
          // Also add class for CSS targeting
          if (opacity > 0.1) {
            scene.classList.add('is-visible');
            scene.style.pointerEvents = 'auto';
          } else {
            scene.classList.remove('is-visible');
            scene.style.pointerEvents = 'none';
          }
            
            // Foreground image - same opacity as scene
            const fgImage = scene.querySelector('.ij-foreground-image');
            if (fgImage) {
              // First scene foreground should also start fully visible
              const fgOpacity = idx === 0 ? 1 : opacity;
              gsap.set(fgImage, { opacity: fgOpacity });
            }

            // Video - play/pause and opacity
            const sceneVideo = root.querySelector(`.ij-layer.bg.video.scene-${idx}`);
            if (sceneVideo) {
              // First scene video should also start fully visible
              const videoOpacity = idx === 0 ? 1 : opacity;
              gsap.set(sceneVideo, { opacity: videoOpacity });
              if (opacity > 0.5) {
                if (sceneVideo.paused) {
                  sceneVideo.play().catch(err => {
                    console.log('Video play failed:', err);
                  });
                }
              } else if (opacity < 0.3) {
                if (!sceneVideo.paused) {
                  sceneVideo.pause();
                }
              }
            }
            
            // Background image opacity
            const sceneBg = root.querySelector(`.ij-layer.bg.scene-${idx}:not(.video)`);
            if (sceneBg) {
              // First scene background should start fully visible, no fade in
              const bgOpacity = idx === 0 ? 1 : opacity;
              gsap.set(sceneBg, { opacity: bgOpacity });
            }
            
            // Parallax - smooth movement throughout scene (only if no video)
            const parallaxProgress = Math.min(sceneProgress, 1);
            const bgY = parallaxProgress * 12;
            if (!sceneVideo && sceneBg) {
              // Apply parallax to background image
              gsap.set(sceneBg, { y: bgY * 0.5 });
            } else if (!sceneVideo) {
              gsap.set(scene, { backgroundPosition: `50% ${bgY}%` });
            }
            
            // Text and CTA animations
            const animateText = scene.getAttribute('data-animate-text') === 'true';
            
            // Animate hero content fade-in for first scene
            const heroContent = scene.querySelector('.ij-hero-content');
            if (heroContent && idx === 0) {
              // Fade in hero content over first 20% of scene progress
              let heroOpacity = 0;
              if (sceneProgress >= 0 && sceneProgress < 0.2) {
                heroOpacity = Math.min(sceneProgress / 0.2, 1);
              } else if (sceneProgress >= 0.2) {
                heroOpacity = 1;
              }
              // Fade out when transitioning to next scene
              if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                heroOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
              }
              gsap.set(heroContent, { opacity: heroOpacity });
            }
            
            // Animate bullet points (always animate, not just when animateText is true)
            // For info scene: animate bullets one by one after heading/subheading and before conclusion
            const bulletItems = scene.querySelectorAll('.ij-bullet-item');
            if (bulletItems.length > 0) {
              // Check if there's a conclusion - if so, animate bullets before it appears
              const hasConclusion = scene.querySelector('.ij-conclusion') !== null;
              const hasSubhead = scene.querySelector('.ij-sub') !== null;
              
              // Determine when to start bullets based on what comes before them
              // If animateText is true: heading finishes at 0.1, subheading at 0.35
              // If animateText is false: everything fades in together at 0.1
              let bulletsStart;
              if (animateText) {
                // Start after subheading if present, otherwise after heading
                bulletsStart = hasSubhead ? 0.35 : 0.2; // Subheading finishes at 0.35, heading at 0.2
              } else {
                // When not animating text, start after initial fade-in completes
                bulletsStart = 0.2;
              }
              
              // Conclusion starts at 0.65 (65% of scene) when animateText is true, or 0.5 when false
              const conclusionStart = hasConclusion ? (animateText ? 0.65 : 0.5) : 0.9; // Leave some space at end if no conclusion
              
              // Calculate available time for bullets - distribute them evenly across this period
              const availableTime = conclusionStart - bulletsStart;
              
              // Ensure we have enough time to animate all bullets
              if (availableTime > 0 && bulletItems.length > 0) {
                // Distribute bullets evenly across available time
                // Each bullet gets a portion of the available time
                const timePerBullet = availableTime / bulletItems.length;
                const bulletAnimationDuration = Math.min(timePerBullet * 0.6, 0.15); // Each bullet animates over 60% of its time slot, max 15%
                
                bulletItems.forEach((item, bulletIdx) => {
                  // Each bullet starts at bulletsStart + (bulletIdx * timePerBullet)
                  // This distributes them evenly across the available time
                  const itemStart = bulletsStart + (bulletIdx * timePerBullet);
                  const bulletProgress = (sceneProgress - itemStart);
                  
                  let bulletOpacity = 0;
                  // Each bullet animates over bulletAnimationDuration
                  if (bulletProgress >= 0 && bulletProgress < bulletAnimationDuration) {
                    bulletOpacity = Math.min(bulletProgress / bulletAnimationDuration, 1);
                  } else if (bulletProgress >= bulletAnimationDuration) {
                    bulletOpacity = 1;
                  }
                  // Don't fade out during hold time - only fade out when transitioning to next scene
                  // During hold time, sceneProgress = 1.0, so we check rawSceneProgress instead
                  if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                    bulletOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
                  }
                  const bulletY = bulletProgress >= 0 && bulletProgress < bulletAnimationDuration ? (1 - bulletProgress / bulletAnimationDuration) * 20 : 0;
                  gsap.set(item, { opacity: bulletOpacity, y: bulletY });
                });
              } else {
                // Fallback: if timing calculation fails, hide all bullets
                bulletItems.forEach(item => {
                  gsap.set(item, { opacity: 0, y: 20 });
                });
              }
            }
            
            // Animate ingredient features (always animate)
            // For ingredient story scene: animate features one by one after body text (or heading if no body) and before bridge text
            const featureItems = scene.querySelectorAll('.ij-feature-item');
            if (featureItems.length > 0) {
              // Check if there's a bridge text - if so, animate features before it appears
              const hasBridgeText = scene.querySelector('.ij-bridge-text') !== null;
              const hasBody = scene.querySelector('.ij-body') !== null;
              
              // Determine when to start features based on what comes before them
              // If body text exists: it finishes at 0.6 (60% of scene) when animateText is true
              // If no body text: start after heading (0.2 when animateText is true, or 0.1 when false)
              let featuresStart;
              if (hasBody) {
                // Start after body text is fully visible
                featuresStart = animateText ? 0.6 : 0.3;
              } else {
                // No body text - start after heading finishes
                if (animateText) {
                  featuresStart = 0.2; // Heading finishes at 0.2 (20% of scene)
                } else {
                  featuresStart = 0.1; // Initial fade-in completes at 0.1
                }
              }
              
              // Bridge text starts at 0.75 when animateText is true (after features have time to animate)
              // or 0.5 when animateText is false
              const bridgeStart = hasBridgeText ? (animateText ? 0.75 : 0.5) : 0.9; // Give features time to animate before bridge appears
              
              // Calculate available time for features - distribute them evenly across this period
              const availableTime = bridgeStart - featuresStart;
              
              // Ensure we have enough time to animate all features
              if (availableTime > 0 && featureItems.length > 0) {
                // Distribute features evenly across available time
                // Each feature gets a portion of the available time
                const timePerFeature = availableTime / featureItems.length;
                const featureAnimationDuration = Math.min(timePerFeature * 0.6, 0.15); // Each feature animates over 60% of its time slot, max 15%
                
                featureItems.forEach((item, featureIdx) => {
                  // Each feature starts at featuresStart + (featureIdx * timePerFeature)
                  // This distributes them evenly across the available time
                  const itemStart = featuresStart + (featureIdx * timePerFeature);
                  const featureProgress = (sceneProgress - itemStart);
                  
                  let featureOpacity = 0;
                  // Each feature animates over featureAnimationDuration
                  if (featureProgress >= 0 && featureProgress < featureAnimationDuration) {
                    featureOpacity = Math.min(featureProgress / featureAnimationDuration, 1);
                  } else if (featureProgress >= featureAnimationDuration) {
                    featureOpacity = 1;
                  }
                  // Don't fade out during hold time - only fade out when transitioning to next scene
                  // During hold time, sceneProgress = 1.0, so we check rawSceneProgress instead
                  if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                    featureOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
                  }
                  const featureY = featureProgress >= 0 && featureProgress < featureAnimationDuration ? (1 - featureProgress / featureAnimationDuration) * 20 : 0;
                  gsap.set(item, { opacity: featureOpacity, y: featureY });
                });
              } else {
                // Fallback: if timing calculation fails, hide all features
                featureItems.forEach(item => {
                  gsap.set(item, { opacity: 0, y: 20 });
                });
              }
            }
            
            // Animate trust sections (always animate, not just when animateText is true)
            const trustSections = scene.querySelectorAll('.ij-trust-section');
            if (trustSections.length > 0) {
              trustSections.forEach((section, sectionIdx) => {
                // Start animating trust sections at scene start (0.1) and stagger them
                const sectionStart = 0.1 + (sectionIdx * 0.25);
                const sectionProgress = sceneProgress - sectionStart;
                let sectionOpacity = 0;
                if (sectionProgress >= 0 && sectionProgress < 0.2) {
                  sectionOpacity = Math.min(sectionProgress / 0.2, 1);
                } else if (sectionProgress >= 0.2) {
                  sectionOpacity = 1;
                }
                // Only fade out when actually transitioning (not during hold phase)
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                  sectionOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
                }
                const sectionY = sectionProgress >= 0 && sectionProgress < 0.2 ? (1 - sectionProgress / 0.2) * 30 : 0;
                gsap.set(section, { opacity: sectionOpacity, y: sectionY });
              });
            }
            
            // Animate product steps (always animate, not just when animateText is true)
            const productSteps = scene.querySelectorAll('.ij-product-step');
            if (productSteps.length > 0) {
              // Check if there's a heading/subheading - start steps after they appear
              const hasHeading = scene.querySelector('.ij-h1') !== null;
              const hasSubhead = scene.querySelector('.ij-sub') !== null;
              
              // Determine when to start product steps
              let stepsStart;
              if (animateText) {
                // Start after subheading if present, otherwise after heading
                stepsStart = hasSubhead ? 0.35 : (hasHeading ? 0.2 : 0.1); // Subheading finishes at 0.35, heading at 0.2
              } else {
                // When not animating text, start after initial fade-in completes
                stepsStart = 0.1;
              }
              
              productSteps.forEach((step, stepIdx) => {
                const stepProgress = sceneProgress - stepsStart - (stepIdx * 0.2);
                let stepOpacity = 0;
                if (stepProgress >= 0 && stepProgress < 0.25) {
                  stepOpacity = Math.min(stepProgress / 0.25, 1);
                } else if (stepProgress >= 0.25) {
                  stepOpacity = 1;
                }
                // Only fade out when actually transitioning (not during hold phase)
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                  stepOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
                }
                const stepY = stepProgress >= 0 && stepProgress < 0.25 ? (1 - stepProgress / 0.25) * 30 : 0;
                gsap.set(step, { opacity: stepOpacity, y: stepY });
              });
            }
            
            // Animate product step single (individual step scenes with image)
            const productStepSingle = scene.querySelector('.ij-product-step-single');
            if (productStepSingle) {
              // Start animating at scene start
              const stepImage = productStepSingle.querySelector('.ij-product-step-image');
              const stepContent = productStepSingle.querySelector('.ij-product-step-content');
              
              // Image animates first
              if (stepImage) {
                let imageOpacity = 0;
                if (sceneProgress >= 0 && sceneProgress < 0.2) {
                  imageOpacity = Math.min(sceneProgress / 0.2, 1);
                } else if (sceneProgress >= 0.2) {
                  imageOpacity = 1;
                }
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                  imageOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
                }
                const imageY = sceneProgress >= 0 && sceneProgress < 0.2 ? (1 - sceneProgress / 0.2) * 30 : 0;
                gsap.set(stepImage, { opacity: imageOpacity, y: imageY });
              }
              
              // Content animates after image
              if (stepContent) {
                const contentStart = 0.2;
                const contentProgress = sceneProgress - contentStart;
                let contentOpacity = 0;
                if (contentProgress >= 0 && contentProgress < 0.2) {
                  contentOpacity = Math.min(contentProgress / 0.2, 1);
                } else if (contentProgress >= 0.2) {
                  contentOpacity = 1;
                }
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                  contentOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
                }
                const contentY = contentProgress >= 0 && contentProgress < 0.2 ? (1 - contentProgress / 0.2) * 30 : 0;
                gsap.set(stepContent, { opacity: contentOpacity, y: contentY });
              }
            }
            
            // Animate ingredient cards (always animate, not just when animateText is true)
            const ingredientCards = scene.querySelectorAll('.ij-ingredient-card');
            if (ingredientCards.length > 0) {
              // Check if there's a heading - start cards after it appears
              const hasHeading = scene.querySelector('.ij-h1') !== null;
              
              // Determine when to start ingredient cards
              let cardsStart;
              if (animateText) {
                // Start after heading finishes
                cardsStart = hasHeading ? 0.2 : 0.1; // Heading finishes at 0.2
              } else {
                // When not animating text, start after initial fade-in completes
                cardsStart = 0.1;
              }
              
              ingredientCards.forEach((card, cardIdx) => {
                const cardProgress = sceneProgress - cardsStart - (cardIdx * 0.15);
                let cardOpacity = 0;
                if (cardProgress >= 0 && cardProgress < 0.2) {
                  cardOpacity = Math.min(cardProgress / 0.2, 1);
                } else if (cardProgress >= 0.2) {
                  cardOpacity = 1;
                }
                // Only fade out when actually transitioning (not during hold phase)
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                  cardOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
                }
                const cardY = cardProgress >= 0 && cardProgress < 0.2 ? (1 - cardProgress / 0.2) * 30 : 0;
                gsap.set(card, { opacity: cardOpacity, y: cardY });
              });
            }
            
            // Animate social proof elements (always animate, not just when animateText is true)
            const expertQuote = scene.querySelector('.ij-expert-quote');
            if (expertQuote) {
              const quoteProgress = sceneProgress - 0.1;
              let quoteOpacity = 0;
              if (quoteProgress >= 0 && quoteProgress < 0.2) {
                quoteOpacity = Math.min(quoteProgress / 0.2, 1);
              } else if (quoteProgress >= 0.2) {
                quoteOpacity = 1;
              }
              // Only fade out when actually transitioning (not during hold phase)
              if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                quoteOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
              }
              const quoteY = quoteProgress >= 0 && quoteProgress < 0.2 ? (1 - quoteProgress / 0.2) * 30 : 0;
              gsap.set(expertQuote, { opacity: quoteOpacity, y: quoteY });
            }

            const customerTestimonial = scene.querySelector('.ij-customer-testimonial');
            if (customerTestimonial) {
              const testimonialProgress = sceneProgress - 0.3;
              let testimonialOpacity = 0;
              if (testimonialProgress >= 0 && testimonialProgress < 0.2) {
                testimonialOpacity = Math.min(testimonialProgress / 0.2, 1);
              } else if (testimonialProgress >= 0.2) {
                testimonialOpacity = 1;
              }
              // Only fade out when actually transitioning (not during hold phase)
              if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                testimonialOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
              }
              const testimonialY = testimonialProgress >= 0 && testimonialProgress < 0.2 ? (1 - testimonialProgress / 0.2) * 30 : 0;
              gsap.set(customerTestimonial, { opacity: testimonialOpacity, y: testimonialY });
            }

            const beforeAfter = scene.querySelector('.ij-before-after');
            if (beforeAfter) {
              const baProgress = sceneProgress - 0.5;
              let baOpacity = 0;
              if (baProgress >= 0 && baProgress < 0.2) {
                baOpacity = Math.min(baProgress / 0.2, 1);
              } else if (baProgress >= 0.2) {
                baOpacity = 1;
              }
              // Only fade out when actually transitioning (not during hold phase)
              if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                baOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
              }
              const baY = baProgress >= 0 && baProgress < 0.2 ? (1 - baProgress / 0.2) * 30 : 0;
              gsap.set(beforeAfter, { opacity: baOpacity, y: baY });
            }

            const professionalUse = scene.querySelector('.ij-professional-use');
            if (professionalUse) {
              const puProgress = sceneProgress - 0.8;
              let puOpacity = 0;
              if (puProgress >= 0 && puProgress < 0.15) {
                puOpacity = Math.min(puProgress / 0.15, 1);
              } else if (puProgress >= 0.15) {
                puOpacity = 1;
              }
              // Only fade out when actually transitioning (not during hold phase)
              if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                puOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
              }
              const puY = puProgress >= 0 && puProgress < 0.15 ? (1 - puProgress / 0.15) * 20 : 0;
              gsap.set(professionalUse, { opacity: puOpacity, y: puY });
            }
            
            // Animate story sections (always animate, not just when animateText is true)
            const storySections = scene.querySelectorAll('.ij-story-section');
            if (storySections.length > 0) {
              storySections.forEach((section, sectionIdx) => {
                // Start animating story sections at scene start and stagger them
                const sectionStart = 0.1 + (sectionIdx * 0.4);
                const sectionProgress = sceneProgress - sectionStart;
                let sectionOpacity = 0;
                if (sectionProgress >= 0 && sectionProgress < 0.3) {
                  sectionOpacity = Math.min(sectionProgress / 0.3, 1);
                } else if (sectionProgress >= 0.3) {
                  sectionOpacity = 1;
                }
                // Only fade out when actually transitioning (not during hold phase)
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                  sectionOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
                }
                const sectionY = sectionProgress >= 0 && sectionProgress < 0.3 ? (1 - sectionProgress / 0.3) * 30 : 0;
                gsap.set(section, { opacity: sectionOpacity, y: sectionY });
              });
            }
            
            // Animate founder scene elements (always animate, not just when animateText is true)
            const founderHeadline = scene.querySelector('.ij-founder-headline');
            if (founderHeadline) {
              const headlineProgress = sceneProgress - 0.1;
              let headlineOpacity = 0;
              if (headlineProgress >= 0 && headlineProgress < 0.2) {
                headlineOpacity = Math.min(headlineProgress / 0.2, 1);
              } else if (headlineProgress >= 0.2) {
                headlineOpacity = 1;
              }
              if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                headlineOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
              }
              const headlineY = headlineProgress >= 0 && headlineProgress < 0.2 ? (1 - headlineProgress / 0.2) * 20 : 0;
              gsap.set(founderHeadline, { opacity: headlineOpacity, y: headlineY });
            }
            
            const founderQuote = scene.querySelector('.ij-founder-quote');
            if (founderQuote) {
              const quoteProgress = sceneProgress - 0.2;
              let quoteOpacity = 0;
              if (quoteProgress >= 0 && quoteProgress < 0.25) {
                quoteOpacity = Math.min(quoteProgress / 0.25, 1);
              } else if (quoteProgress >= 0.25) {
                quoteOpacity = 1;
              }
              if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                quoteOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
              }
              const quoteY = quoteProgress >= 0 && quoteProgress < 0.25 ? (1 - quoteProgress / 0.25) * 30 : 0;
              gsap.set(founderQuote, { opacity: quoteOpacity, y: quoteY });
            }
            
            const founderBody = scene.querySelector('.ij-founder-body');
            if (founderBody) {
              const bodyProgress = sceneProgress - 0.45;
              let bodyOpacity = 0;
              if (bodyProgress >= 0 && bodyProgress < 0.25) {
                bodyOpacity = Math.min(bodyProgress / 0.25, 1);
              } else if (bodyProgress >= 0.25) {
                bodyOpacity = 1;
              }
              if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                bodyOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
              }
              const bodyY = bodyProgress >= 0 && bodyProgress < 0.25 ? (1 - bodyProgress / 0.25) * 30 : 0;
              gsap.set(founderBody, { opacity: bodyOpacity, y: bodyY });
            }
            
            const founderSignature = scene.querySelector('.ij-founder-signature');
            if (founderSignature) {
              const signatureProgress = sceneProgress - 0.7;
              let signatureOpacity = 0;
              if (signatureProgress >= 0 && signatureProgress < 0.2) {
                signatureOpacity = Math.min(signatureProgress / 0.2, 1);
              } else if (signatureProgress >= 0.2) {
                signatureOpacity = 1;
              }
              if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                signatureOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
              }
              const signatureY = signatureProgress >= 0 && signatureProgress < 0.2 ? (1 - signatureProgress / 0.2) * 20 : 0;
              gsap.set(founderSignature, { opacity: signatureOpacity, y: signatureY });
            }
            
            const founderImage = scene.querySelector('.ij-founder-image');
            if (founderImage) {
              const imageProgress = sceneProgress - 0.3;
              let imageOpacity = 0;
              if (imageProgress >= 0 && imageProgress < 0.3) {
                imageOpacity = Math.min(imageProgress / 0.3, 1);
              } else if (imageProgress >= 0.3) {
                imageOpacity = 1;
              }
              if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.98) {
                imageOpacity = Math.max((1 - rawSceneProgress) / 0.02, 0);
              }
              const imageY = imageProgress >= 0 && imageProgress < 0.3 ? (1 - imageProgress / 0.3) * 30 : 0;
              gsap.set(founderImage, { opacity: imageOpacity, y: imageY });
            }
            
            if (animateText) {
              // Staggered animation: header → subheader → body → CTA
              const h1 = scene.querySelector('.ij-h1');
              const sub = scene.querySelector('.ij-sub');
              const body = scene.querySelector('.ij-body');
              const cta = scene.querySelector('.ij-cta');
              
              // Header: fade in at 0% (scene start)
              if (h1) {
                let h1Opacity = sceneProgress >= 0 ? Math.min(sceneProgress / 0.1, 1) : 0;
                // Only fade out when actually transitioning (not during hold phase)
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.95) {
                  h1Opacity = (1 - rawSceneProgress) / 0.05;
                }
                const h1Y = sceneProgress < 0.1 ? (1 - sceneProgress / 0.1) * 40 : 0;
                gsap.set(h1, { opacity: h1Opacity, y: h1Y });
              }
              
              // Subheader: fade in at 25% of scene
              if (sub) {
                let subOpacity = 0;
                if (sceneProgress >= 0.25) {
                  subOpacity = Math.min((sceneProgress - 0.25) / 0.1, 1);
                } else if (sceneProgress < 0.25) {
                  subOpacity = 0;
                }
                // Only fade out when actually transitioning (not during hold phase)
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.95) {
                  subOpacity = (1 - rawSceneProgress) / 0.05;
                }
                const subY = sceneProgress >= 0.25 && sceneProgress < 0.35 ? (1 - (sceneProgress - 0.25) / 0.1) * 40 : 0;
                gsap.set(sub, { opacity: subOpacity, y: subY });
              }
              
              // Body: fade in at 50% of scene
              if (body) {
                let bodyOpacity = 0;
                if (sceneProgress >= 0.5) {
                  bodyOpacity = Math.min((sceneProgress - 0.5) / 0.1, 1);
                }
                // Only fade out when actually transitioning (not during hold phase)
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.95) {
                  bodyOpacity = (1 - rawSceneProgress) / 0.05;
                }
                const bodyY = sceneProgress >= 0.5 && sceneProgress < 0.6 ? (1 - (sceneProgress - 0.5) / 0.1) * 40 : 0;
                gsap.set(body, { opacity: bodyOpacity, y: bodyY });
              }
              
              // CTA: fade in at 75% of scene
              if (cta) {
                let ctaOpacity = 0;
                if (sceneProgress >= 0.75) {
                  ctaOpacity = Math.min((sceneProgress - 0.75) / 0.1, 1);
                }
                // Only fade out when actually transitioning (not during hold phase)
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.95) {
                  ctaOpacity = (1 - rawSceneProgress) / 0.05;
                }
                const ctaY = sceneProgress >= 0.75 && sceneProgress < 0.85 ? (1 - (sceneProgress - 0.75) / 0.1) * 40 : 0;
                gsap.set(cta, { opacity: ctaOpacity, y: ctaY });
              }

              // Animate conclusion and bridge text
              const conclusion = scene.querySelector('.ij-conclusion');
              if (conclusion) {
                const conclusionProgress = sceneProgress - 0.7;
                let conclusionOpacity = 0;
                if (conclusionProgress >= 0 && conclusionProgress < 0.15) {
                  conclusionOpacity = Math.min(conclusionProgress / 0.15, 1);
                } else if (conclusionProgress >= 0.15) {
                  conclusionOpacity = 1;
                }
                // Only fade out when actually transitioning (not during hold phase)
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.95) {
                  conclusionOpacity = (1 - rawSceneProgress) / 0.05;
                }
                const conclusionY = conclusionProgress >= 0 && conclusionProgress < 0.15 ? (1 - conclusionProgress / 0.15) * 20 : 0;
                gsap.set(conclusion, { opacity: conclusionOpacity, y: conclusionY });
              }

              const bridgeText = scene.querySelector('.ij-bridge-text');
              if (bridgeText) {
                // Bridge text starts at 0.75 when animateText is true (after features have time to animate)
                // or 0.5 when animateText is false
                const bridgeStartTime = animateText ? 0.75 : 0.5;
                const bridgeProgress = sceneProgress - bridgeStartTime;
                let bridgeOpacity = 0;
                if (bridgeProgress >= 0 && bridgeProgress < 0.15) {
                  bridgeOpacity = Math.min(bridgeProgress / 0.15, 1);
                } else if (bridgeProgress >= 0.15) {
                  bridgeOpacity = 1;
                }
                // Only fade out when actually transitioning (not during hold phase)
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.95) {
                  bridgeOpacity = (1 - rawSceneProgress) / 0.05;
                }
                const bridgeY = bridgeProgress >= 0 && bridgeProgress < 0.15 ? (1 - bridgeProgress / 0.15) * 20 : 0;
                gsap.set(bridgeText, { opacity: bridgeOpacity, y: bridgeY });
              }

              // Animate kit showcase
              const kitShowcase = scene.querySelector('.ij-kit-showcase');
              if (kitShowcase) {
                const kitProgress = sceneProgress - 0.1;
                let kitOpacity = 0;
                if (kitProgress >= 0 && kitProgress < 0.2) {
                  kitOpacity = Math.min(kitProgress / 0.2, 1);
                } else if (kitProgress >= 0.2) {
                  kitOpacity = 1;
                }
                // Only fade out when actually transitioning (not during hold phase)
                if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.95) {
                  kitOpacity = (1 - rawSceneProgress) / 0.05;
                }
                const kitY = kitProgress >= 0 && kitProgress < 0.2 ? (1 - kitProgress / 0.2) * 30 : 0;
                gsap.set(kitShowcase, { opacity: kitOpacity, y: kitY });
              }
            } else {
              // All text fades in together at scene start (but trust sections, product steps, ingredient cards, and social proof elements are animated separately above)
              const texts = scene.querySelectorAll('.ij-h1, .ij-sub, .ij-body, .ij-cta, .ij-bullet-item, .ij-feature-item, .ij-conclusion, .ij-bridge-text, .ij-kit-showcase');
              texts.forEach(text => {
                let textOpacity = 1;
                if (sceneProgress < 0.1) {
                  textOpacity = sceneProgress / 0.1; // Fade in over first 10%
                // Only fade out when actually transitioning (not during hold phase)
                } else if (idx < sceneCount - 1 && !isInHoldPhase && rawSceneProgress > 0.95) {
                  textOpacity = Math.max((1 - rawSceneProgress) / 0.05, 0); // Fade out over last 5%
                }
                const textY = sceneProgress < 0.1 ? (1 - sceneProgress / 0.1) * 40 : 0;
                gsap.set(text, { opacity: textOpacity, y: textY });
              });
            }
          } else {
            // Other scenes: hidden
            gsap.set(scene, { opacity: 0, pointerEvents: 'none' });
            scene.classList.remove('is-visible');
            scene.style.pointerEvents = 'none';
            const fgImage = scene.querySelector('.ij-foreground-image');
            if (fgImage) {
              gsap.set(fgImage, { opacity: 0 });
            }
            const sceneVideo = root.querySelector(`.ij-layer.bg.video.scene-${idx}`);
            if (sceneVideo) {
              gsap.set(sceneVideo, { opacity: 0 });
              sceneVideo.pause();
            }
            const sceneBg = root.querySelector(`.ij-layer.bg.scene-${idx}:not(.video)`);
            if (sceneBg) {
              gsap.set(sceneBg, { opacity: 0 });
            }
            const texts = scene.querySelectorAll('.ij-h1, .ij-sub, .ij-body, .ij-cta, .ij-bullet-item, .ij-feature-item, .ij-product-step, .ij-trust-section, .ij-ingredient-card, .ij-expert-quote, .ij-customer-testimonial, .ij-before-after, .ij-conclusion, .ij-bridge-text, .ij-kit-showcase, .ij-professional-use');
            texts.forEach(text => {
              gsap.set(text, { opacity: 0, y: 40 });
            });
          }
        });
      }
    
    // Single ScrollTrigger that controls everything based on progress
    const animationTrigger = ScrollTrigger.create({
      trigger: root,
      start: 'top top',
      end: `+=${totalScrollLength}px`,
      scrub: true,
      immediateRender: false,
      onUpdate: (self) => {
        updateAnimations(self.progress, totalScrollLength);
      },
      onEnter: () => {
        // Ensure animations are applied when entering the trigger
        updateAnimations(0, totalScrollLength);
      }
    });
    
    // Call immediately to set initial state
    updateAnimations(0, totalScrollLength);
  });
})();
